import { RoleModel } from '.';
import { PaginationCriteria } from '../../core';

export interface UserModel {
   id: string;
   userName: string;
   initials: string;
   firstName: string;
   lastName: string;
   fullName: string;
   isActive: boolean;
   roles: UserRoleModel[];
   features: FeatureModel[];
}

export interface UserListItemModel {
   id: string;
   userName: string;
   fullName: string;
   isActive: boolean;
   locationCount: number;
   globalRoles: string;
}

export interface UserRoleModel extends RoleModel {
   locationId?: string;
}

export interface FeatureModel {
   name: string;
}

export interface UserListCriteria extends PaginationCriteria {
   q?: string;
   userName?: string;
}
